<template>
  <form
    class="bg-efblue-9 w-full shadow-darkflat text-white rounded flex flex-col p-6 md:p-10"
    @submit.prevent
  >
    <div class="mb-8">
      <div class="relative flex flex-col md:flex-row mb-4">
        <BookingNumber
          :value="bookingNumber"
          :valid="!$v.bookingNumber.$invalid"
          :disabled="showLoader"
          @input="bookingNumber = $event"
        />

        <DateOfBirth
          :date-of-birth="dateOfBirth"
          :disabled="showLoader"
          @input="dateOfBirth = $event"
        />
      </div>

      <BaseContextualErrorMessage :message="error" color="light" />
    </div>

    <Consent
      :checked="consent"
      :valid="!$v.consent.$invalid"
      :disabled="showLoader"
      @change="consent = $event"
    />

    <hr class="mb-8" />

    <div>
      <MainButton
        title="Confirm"
        purple
        medium
        shadow
        :disabled="$v.$invalid"
        :show-loader="showLoader"
        @click="checkBooking"
      />
    </div>
  </form>
</template>

<script>
import { alphaNum, required } from 'vuelidate/lib/validators';

import BookingNumber from '@/components/Start/ConfirmUserForm/BookingNumber.vue';
import DateOfBirth from '@/components/Start/ConfirmUserForm/DateOfBirth.vue';
import Consent from '@/components/Start/ConfirmUserForm/Consent.vue';

export default {
  name: 'ConfirmUserForm',
  components: {
    BookingNumber,
    DateOfBirth,
    Consent
  },
  validations: {
    bookingNumber: {
      alphaNum,
      required
    },
    consent: {
      checked: (value) => value === true,
      required
    },
    dateOfBirth: {
      required
    }
  },
  data: () => ({
    bookingNumber: '',
    consent: false,
    dateOfBirth: '',
    showLoader: false,
    showModal: false,
    error: ''
  }),
  methods: {
    checkBooking() {
      this.showLoader = true;

      this.error = '';

      this.$store
        .dispatch('GET_CUSTOMER', {
          efSalesRefCode: this.bookingNumber,
          birthDate: this.dateOfBirth
        })
        .then(() => this.$emit('completed'))
        .catch(() => {
          this.error = `The combination of booking number '${this.bookingNumber}' and birth date '${this.dateOfBirth}' does not match our register, please double check and try again`;
        })
        .finally(() => (this.showLoader = false));
    }
  }
};
</script>
